import $ from 'jquery';

const FormValidation = (() => {
  function addValidation(form) {
    const $form = $(form);
    $form.form({ fields: $form.data('validate'), inline: true });
  }

  const init = () => {
    [].slice.call(document.querySelectorAll('.ui.form.js__form_validation')).map(addValidation);
  };

  return {
    init,
  };
})();

export default FormValidation;
